import { render, staticRenderFns } from "./QuizzesPage.vue?vue&type=template&id=ebfdfcda&scoped=true&"
import script from "./QuizzesPage.vue?vue&type=script&lang=js&"
export * from "./QuizzesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfdfcda",
  null
  
)

export default component.exports